export default __webpack_public_path__ + "static/media/prj_2.066637ea.png";